export const SET_DATA = (state, { id, data }) => {
    state[id] = data
}
export const finalCategories = (state) => {
    let cat = state.categories
    let finaleCat = {}
    cat.forEach(e => {
        if (!finaleCat[e.category_id]) {
            finaleCat[e.category_id] = []
            finaleCat[e.category_id].push(e)
        } else {
            finaleCat[e.category_id].push(e)
        }
    })
    let arr = []
    Object.keys(finaleCat).forEach((e, j) => {
        let obj = {
            category_id: finaleCat[e][0].category_id,
            en_category: finaleCat[e][0].en_category,
            category: finaleCat[e][0].category,
            isActive: j == 0,
            sub: []
        }
        finaleCat[e].forEach((c, i) => {
            obj.sub.push({
                subcategory: c.subcategory,
                en_subcategory: c.en_subcategory,
                subcategory_id: c.subcategory_id,
                id: c.subcategory_id,
                selfId:finaleCat[e][0].category_id
            })
        })
        arr.push(obj)
    })
    state.filterCat = arr
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/mutations.js